export { inspector, simpleInspector } from './inspector'
export { fileInspector } from './fileInspector'
